import Carousel from "./core_modules/carousel"
import ImageZoom from "./core_modules/imageZoom"
import { debounce } from './core_modules/debounce';
import { checkHCaptcha } from './core_modules/hcapchaCheck';

class App {
    private body = document.body
    private navToggleButton = document.querySelector("[data-toggle]")
    private navBar = document.querySelector("[data-nav]")
    private navBarList = document.querySelector(".navBarList")
    private navBarListItem = Array.from(document.querySelectorAll(".navBarListItem"))
    private navBarDropdownListItem = Array.from(document.querySelectorAll(".navBarDropdownListItem"))
    private productChoices = Array.from(document.querySelectorAll('.choices'))
    // private productShowcases = Array.from(document.querySelectorAll("[data-image-showcase] li img")) as HTMLElement[]
    private customSelect = document.querySelector(".custom-select") as HTMLElement
    private selectElement = this.customSelect?.querySelector(".input-outlined") as HTMLElement
    private selectItems = document.querySelector("[data-finish-items]") as HTMLElement
    private selectItem = this.selectItems ? Array.from(this.selectItems.querySelectorAll("li")) : [] as HTMLElement[]
    private selectInput = document.querySelector("[data-finish-input]") as HTMLInputElement
    private customColourSelect = document.querySelector(".custom-colour-select") as HTMLElement
    private selectColourElement = this.customColourSelect?.querySelector(".input-outlined") as HTMLElement
    private selectColourItems = document.querySelector("[data-colour-items]") as HTMLElement
	private selectColourItem = this.selectColourItems ? Array.from(this.selectColourItems.querySelectorAll("li")) : [] as HTMLElement[]
    private selectColourInput = document.querySelector("[data-colour-input]") as HTMLInputElement
    private rosettesInput = document.querySelector("#rosettes") as HTMLInputElement
    private meshInput = document.querySelector("#mesh") as HTMLInputElement
    private drillInput = document.querySelector("#drilling") as HTMLInputElement
    private infillMaterialInput = document.querySelector("#infillMaterial") as HTMLInputElement
    private brassFinishInput = document.querySelector("#brassFinish") as HTMLInputElement
	private basketButton = document.getElementById('addToBasket');
    private pvcColourSelector = document.querySelector("#pvcColour") as HTMLInputElement
	private specialFinishSelected = false;

    // Search Btn
    private searchIcon = document.querySelector('[data-search-icon]') as HTMLElement

    //Leenix amends
    private recalcMonitorInputs = document.querySelectorAll('input.recalcMonitor') as NodeListOf<HTMLInputElement>

    constructor() {
        this.initApp()
        new ImageZoom("dataImage", "dataResult", 1024)
        // checkHCaptcha();
    }

    /* Register your functions here */
    private initApp(): void {
        this.body.style.overflowX = 'hidden'
        this.navToggleButton?.addEventListener("click", this.handleNavigationToggle.bind(this))
        this.handleActiveLinkOnclick()
        this.handleActiveLinkOnPageLoad()
        this.handleProductChoiceClick()
        this.handleCustomSelect()
        this.handleSelectUpdate()
        document.addEventListener("click", this.handleCloseSelect.bind(this))
        // this.handleProductShowCase()
        this.handleSearchClick()
        this.handleRemoveSearch()
		this.basketButton?.addEventListener('click', (e) => {
			e.preventDefault();
			this.asyncPriceCalc(true);
		})

		this.updateBasketTotalItems()
        this.clickAllDefaultClassElements()
        this.priceMonitor()
    }

    /**
     * @function HELPER
     * @returns { string }
     * @description Current page url string
     */
    private getCurrentPage(): string {
        return window.location.pathname;
    }

    /**
     * @function HELPER
     * @param listItem 
     * @param classList
     * @description Adds active state class to list item element 
     */
    private setActiveLink(listItem: Element, classList: string): void {
        if (listItem.querySelector("a")?.getAttribute("href") === this.getCurrentPage()) {
            listItem.classList.add(classList)
            listItem.closest(".navBarListItem") && listItem.closest(".navBarListItem")?.classList.add(classList)
        }
    }

    private handleCustomSelect(): void {
        this.selectElement && this.selectElement?.classList.toggle("select-arrow-active")
        this.selectItems && this.selectItems?.classList.toggle("select-hide")        

		// finishings dropdown
        if(this.customSelect) {
            this.customSelect?.addEventListener("click", (e) => {
                e.stopPropagation()
                this.selectElement?.classList.toggle("select-arrow-active")
                this.selectItems?.classList.toggle("select-hide")
            })
        }

		this.selectColourElement && this.selectColourElement?.classList.toggle("select-arrow-active")
        this.selectColourItems && this.selectColourItems?.classList.toggle("select-hide")

		// infill colour dropdown
		if(this.customColourSelect) {
			this.customColourSelect?.addEventListener("click", (e) => {
                e.stopPropagation()
                this.selectColourElement?.classList.toggle("select-arrow-active")
                this.selectColourItems?.classList.toggle("select-hide")
            })
		}
    }


    private handleSelectUpdate(): void {

        if (this.selectItems) {
            this.selectItems.addEventListener('click', (e) => {
                const target = e.target as HTMLElement
                const listElement = target.closest(".select-item") as HTMLElement
                const newListElement = document.createElement('div')
                newListElement.innerHTML = listElement.innerHTML
                newListElement.classList.add("selected-item")

                for (const item of this.selectItem) {
                    if (item.classList.contains("active")) {
                        item.classList.remove("active")
                    }
                }

                const text = listElement?.querySelector(".text") as HTMLElement

                if (text?.innerHTML) {
                    listElement.classList.add("active")
                    this.selectElement.innerHTML = "";
                    this.selectElement.append(newListElement)
                    this.customSelect.classList.add("has-select-item")
                    this.selectElement.style.textTransform = "capitalize"
                    this.selectInput.value = listElement.dataset.finishId as string
                }

                this.recalcPriceQueue()
				this.handleFinishSelect()
            })
        }

		if(this.selectColourItems) {
			this.selectColourItems.addEventListener('click', (e) => {
                const target = e.target as HTMLElement
                const listElement = target.closest(".select-item") as HTMLElement
                const newListElement = document.createElement('div')
                newListElement.innerHTML = listElement.innerHTML
                newListElement.classList.add("selected-item")

                for (const item of this.selectColourItem) {
                    if (item.classList.contains("active")) {
                        item.classList.remove("active")
                    }
                }

                const text = listElement?.querySelector(".text") as HTMLElement

                if (text?.innerHTML) {
                    listElement.classList.add("active")
                    this.selectColourElement.innerHTML = "";
                    this.selectColourElement.append(newListElement)
                    this.customColourSelect.classList.add("has-select-item")
                    this.selectColourElement.style.textTransform = "capitalize"
                    this.selectColourInput.value = listElement.dataset.pvcColourId as string
                }

                this.recalcPriceQueue()
            })
		}
    }

	private handleFinishSelect() {

		let polishedChoice = document.getElementById("polished-choice") as HTMLSpanElement;
		let satinChoice = document.getElementById("satin-choice") as HTMLSpanElement;
		let finishId = document.querySelector('input[name="finishId"]') as HTMLInputElement;
		let brassFinishValue = document.querySelector('input[name="brassFinish"]') as HTMLInputElement;

		// exit early if any required element is missing from the page
		if (!polishedChoice || !satinChoice || !finishId || !brassFinishValue) {
			return;
		}

		if (parseInt(finishId.value) != 0) {

			// set special finish selector as selected
			this.specialFinishSelected = true;

			// disabled polished and satin choices values and styles
			polishedChoice.style.pointerEvents = "none";
			satinChoice.style.pointerEvents = "none";
			polishedChoice.classList.remove("active");
			polishedChoice.classList.add("disabled");
			satinChoice.classList.remove("active");
			satinChoice.classList.add("disabled");

			// set brass finish value as empty
			brassFinishValue.value = "";
			
		} else {

			// set special finish selector as "disabled"
			this.specialFinishSelected = false;

			// enable polished and satin choices values and styles
			// set polished as default 
			polishedChoice.style.pointerEvents = "auto";
			satinChoice.style.pointerEvents = "auto";
			polishedChoice.classList.add("active");
			polishedChoice.classList.remove("disabled");
			brassFinishValue.value = "polished";
			satinChoice.classList.remove("disabled");

		}
		
	}

    private handleCloseSelect(): void {
        if (this.selectItems) this.selectItems.classList.add('select-hide')
        if (this.selectElement) this.selectElement?.classList.remove("select-arrow-active")
        if (this.selectColourItems) this.selectColourItems.classList.add('select-hide')
        if (this.selectColourElement) this.selectColourElement?.classList.remove("select-arrow-active")
    }


    // FUNCTION DECLARATIONS
    private handleNavigationToggle(): void {
        this.navBar?.toggleAttribute("data-menu-open")
        this.navBar?.setAttribute("aria-expanded", "")
        this.body.removeAttribute('style')
        if (this.navBar?.hasAttribute("data-menu-open")) {
            this.navBar.setAttribute("aria-expanded", "true")
            this.navToggleButton?.setAttribute("aria-expanded", "true")
            // this.body.style.overflow = "hidden"
        } else {
            this.navBar?.setAttribute("aria-expanded", "false")
            this.navToggleButton?.setAttribute("aria-expanded", "false")
            this.body.removeAttribute('style')
            // this.body.style.overflowX = "hidden"
        }
    }

    private handleActiveLinkOnPageLoad(): void {
        this.navBarListItem.forEach(listItem => {
            this.setActiveLink(listItem, "active");
        })

        this.navBarDropdownListItem.forEach(listItem => {
            this.setActiveLink(listItem, "active")
        })
    }

    private handleActiveLinkOnclick(): void {
        this.navBarList?.addEventListener("click", (e) => {
            // store the target value in a variable
            const target = e.target as HTMLAnchorElement;

            // get target attribute for current page
            const currentPage = target.getAttribute("href");

            // show the navbar menu
            target.nextElementSibling?.toggleAttribute("data-dropdown-menu")

            // If link is already active on page load, move on.
            if (target.closest(".navBarListItem")?.classList.contains("active")) return

            // clear the active state if no link is already active on page load
            this.navBarListItem.forEach(listItem => listItem.classList.remove("active"));
            this.navBarDropdownListItem.forEach(listItem => listItem.classList.remove("active"));

            // check the parent element of target value and add active state to the parent when clicked
            // TODO: check if target href attribute matches current page url
            if (target.closest(".navBarListItem") && currentPage === this.getCurrentPage()) {
                target.closest(".navBarListItem")?.classList.add("active")
            }

            if (target.closest(".navBarDropdownListItem") && currentPage === this.getCurrentPage()) {
                target.closest(".navBarDropdownListItem")?.classList.add("active")
            }
        })
    }

    private handleProductChoiceClick(): void {

        this.productChoices.forEach(choice => {
            choice.addEventListener("click", (evt) => {
                const target = evt.target as HTMLElement
                const current = target.closest(".choice")?.querySelector(".input-outlined.active") as HTMLElement
                const productType = target.closest(".choices")?.querySelector(".product-type")
                const productFitting = target.closest(".choices")?.querySelector(".product-fitting")
                const productInfillMaterial = target.closest(".choices")?.querySelector(".product-infill-material")
                const productInBrassFinish = target.closest(".choices")?.querySelector(".product-brass-finish")

                if (productType) {
                    this.rosettesInput.value = `${target.textContent?.toLowerCase()}`
                }

                if (productFitting?.textContent === "Mesh") {
                    this.meshInput.value = `${target.textContent?.toLowerCase()}`
                }

                if (productFitting?.textContent === "Drilling") {
                    this.drillInput.value = `${target.textContent?.toLowerCase()}`
                }

				if(productInfillMaterial?.textContent === "Infill Material") {
					this.infillMaterialInput.value = `${target.textContent?.toLowerCase()}`

					if (this.infillMaterialInput.value === "metal") {
						this.pvcColourSelector.style.display = "none";
					} else {
						this.pvcColourSelector.style.display = "block";
					}
				}

				if(productInBrassFinish?.textContent === "Brass Finish" && !this.specialFinishSelected) {
					this.brassFinishInput.value = `${target.textContent?.toLowerCase()}`
				}

                if (current?.classList.contains("active")) {
                    current.classList.remove("active")
                }

                target.classList.add("active")

                if (current?.classList.contains("active")) {
                    current.classList.remove("active")
                }

                this.recalcPriceQueue()
            })

        })

    }

    // Handle Search Functionality
    private handleSearchClick(): void {
        const searchDiv = document.querySelector('.searchDiv') as HTMLElement
        const searchForm = document.getElementById('searchProductForm') as HTMLFormElement

        this.searchIcon?.addEventListener('click', function (e) {
            searchDiv.classList.toggle('search-open')

            if (!searchDiv.classList.contains('search-open')) {
                searchForm.reset()
            }
        })
    }

    private handleRemoveSearch(): void {
        this.body.addEventListener('click', function (e) {
            const target = e.target as HTMLElement

            if (!(target.classList.contains('search-icon') ||
                target.classList.contains('search-input') ||
                target.classList.contains('search-btn') ||
                target.id === 'search' ||
                target.id === 'searchProductForm' ||
                target.id === 'searchsvg')) {
                (document.querySelector('.searchDiv') as HTMLElement).classList.remove('search-open'),
                    (document.getElementById('searchProductForm') as HTMLFormElement).reset()

            }
        })
    }

    // LEE's Code
    private priceMonitor(): void {

        if (!document.getElementById('product-order')) return;

        this.recalcPrice();
        this.recalcMonitorInputs.forEach(input => {
            input.addEventListener('input', this.recalcPriceQueue);
        })

        //hock into form submit to enable all disabled inputs on form submission
        document.getElementById('product-order')?.addEventListener('submit', (event) => {
            // Prevent the default form submission
            event.preventDefault();
            
            let form = event.target as HTMLFormElement;

            // Get all input elements within the form
            const inputs = form.getElementsByTagName('input');

            //get min-sqm
            let minsqm = form.dataset.minsqm ? parseFloat(form.dataset.minsqm) : 0;
            if(minsqm > 0){
                let sqmInput = document.getElementById('sqm') as HTMLInputElement;
                let wholesheetCheckbox = document.getElementById('wholesheet') as HTMLInputElement;
                let isWholeSheet = (wholesheetCheckbox && wholesheetCheckbox.checked);

                if (isWholeSheet) {
                    console.log("Whole sheet order, no min sqm check");                    
                } else {
                    if(parseFloat(sqmInput.value) < minsqm) {
                        alert("Minimum size is " + minsqm + "m²");
                        return;
                    }
                }
            }

            // Loop through each input element and enable it if it's disabled
            for (let i = 0; i < inputs.length; i++) {
                if (inputs[i].disabled) {
                    inputs[i].disabled = false;
                }
            }

            // Continue with the form submission
            (event.target as HTMLFormElement).submit();
        });
    }

    private recalcPriceQueue = debounce(() => {
        this.recalcPrice();
    }, 800);

	// responsible for the integrity and validation of the dom
    private recalcPrice = () => {

        let wholesheetCheckbox = document.getElementById('wholesheet') as HTMLInputElement;
        let isWholeSheet = (wholesheetCheckbox && wholesheetCheckbox.checked);

        let widthInput = document.getElementById('width') as HTMLInputElement;
        let heightInput = document.getElementById('height') as HTMLInputElement;

        if (isWholeSheet) {
            if (widthInput) widthInput.disabled = true;
            if (heightInput) heightInput.disabled = true;
        } else {
            if (widthInput) widthInput.disabled = false;
            if (heightInput) heightInput.disabled = false;
        }

        //first enforce all min max values
        this.recalcMonitorInputs.forEach(input => {
            const min = parseInt(input.getAttribute('min') as string)
            const max = parseInt(input.getAttribute('max') as string)
            const val = parseInt(input.value)

            if (val < min) {
                input.value = min.toString()
            }
            if (max > 0 && (isWholeSheet || (val > max))) {
                input.value = max.toString()
            }
        })

        let form = document.getElementById('product-order') as HTMLFormElement;

        //get form values
        let formValues = {
            mesh: (document.getElementsByName('mesh')[0] as HTMLInputElement)?.value,
            quantity: parseInt((document.getElementsByName('quantity')[0] as HTMLInputElement)?.value),
            width: (document.getElementsByName('width')[0] as HTMLInputElement)?.value,
            height: (document.getElementsByName('height')[0] as HTMLInputElement)?.value,
        };

        let widthInMeters = parseInt(formValues.width) / 1000;

        if (form.dataset.type != "nosing") {
			if (isWholeSheet && formValues.mesh != 'none') {
                let meshDefaultElement = document.getElementById('mesh-default');

                if (meshDefaultElement) {
                    alert("Mesh is not available for whole sheet orders");
                    meshDefaultElement.click();
                }
                return;
            }

            //calc sqm
            let sqmPriceInput = document.getElementById('indictivePriceSQM') as HTMLInputElement;
            let sqmInput = document.getElementById('sqm') as HTMLInputElement;

            if (wholesheetCheckbox && wholesheetCheckbox.checked) {
                sqmInput.value = "Whole Sheet";
                sqmPriceInput.value = "N/A";
            } else {

                if (sqmInput && formValues.width && formValues.height) {

                    let heightInMeters = parseInt(formValues.height) / 1000;
                    let sqm = widthInMeters * heightInMeters;
                    sqmInput.value = sqm.toFixed(2).toString() + "m²";

                }
            }
        }

		// call the api calc method
		this.asyncPriceCalc();
    }

	private asyncPriceCalc(addToBasket: boolean = false) {

		//get html form
		let form = document.getElementById('product-order') as HTMLFormElement;
		let wholesheetCheckbox = document.getElementById('wholesheet') as HTMLInputElement;
        let isWholeSheet = (wholesheetCheckbox && wholesheetCheckbox.checked);

		// build post parameters from dom
		let parameters: [string, any][] = [
			['pageId', form.dataset.pageid ? parseInt(form.dataset.pageid) : 0],
			['finishId', (document.getElementsByName('finishId')[0] as HTMLInputElement)?.value],			
			['width', (document.getElementsByName('width')[0] as HTMLInputElement)?.value],
			['height', (document.getElementsByName('height')[0] as HTMLInputElement)?.value],
			['quantity', (document.getElementsByName('quantity')[0] as HTMLInputElement)?.value],
			['isWholeSheet', (document.getElementById('wholesheet') as HTMLInputElement)?.checked ? 1 : 0],
			['mesh', (document.getElementsByName('mesh').length > 0 ? (document.getElementsByName('mesh')[0] as HTMLInputElement).value : '')],
			['drilling', (document.getElementsByName('drilling').length > 0 ? (document.getElementsByName('drilling')[0] as HTMLInputElement).value : '')],
			['infillMaterial', (document.getElementsByName('infillMaterial').length > 0 ? (document.getElementsByName('infillMaterial')[0] as HTMLInputElement).value : '')],
			['pvcColourId', (document.getElementsByName('pvcColourId')[0] as HTMLInputElement)?.value],
			['brassFinish', (document.getElementsByName('brassFinish').length > 0 ? (document.getElementsByName('brassFinish')[0] as HTMLInputElement).value : '')],
  			['rosette', (document.getElementsByName('rosettes').length > 0 ? (document.getElementsByName('rosettes')[0] as HTMLInputElement).value : '')],
			['addToBasket', addToBasket ? 1 : 0]
		];

		console.table(parameters);

		let urlParams = new URLSearchParams(parameters);
	
		let url = `/api?action=returnCalcPrice`;

		// build price response type
		interface apiResponse {
			indicativePriceSQM: number;
			price: number;
		}
		
		// dom price inputs
		let sqmPriceInput = document.getElementById('indictivePriceSQM') as HTMLInputElement;
        let indicativePriceInput = document.getElementById('indictivePrice') as HTMLInputElement;

		//use post method
		fetch(url, 
			{ 
				method: 'POST', 
				body: urlParams.toString(), 
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' } 
			}
		)
		.then(response => response.json())
		.then((data: apiResponse) => {

			if (addToBasket) {
				return this.productAddedToBasket();
			}

			if (sqmPriceInput && !isWholeSheet) {
				sqmPriceInput.value = "£" + data.indicativePriceSQM;
			}

			indicativePriceInput.value = "£" + data.price;
			
		})
		.catch(error => {
			console.log(error);
		});
	}

    private clickAllDefaultClassElements(): void {
        const elements = document.getElementsByClassName('default');

        for (let i = 0; i < elements.length; i++) {
            (elements[i] as HTMLElement).click();
        }
    }

	private productAddedToBasket(): void {
		//@todo ellis
        let toast = document.querySelector('.toast') as HTMLElement
        let btnClose = toast?.querySelector('.btn-close') as HTMLButtonElement

        toast.classList.add('product-added')

        setTimeout(() => {
            toast.classList.remove('product-added') 
        }, 2000)

        btnClose.addEventListener('click', () => {
            toast.classList.remove('product-added')
        })
        
		// alert("Product added to basket");

		this.updateBasketTotalItems();
	}

	private updateBasketTotalItems() : void {

		let basketTotalItems = document.getElementById('basketTotalItems') as HTMLSpanElement;

		fetch(`/api?action=returnBasketTotalItems`, 
			{ 
				method: 'GET', 
			}
		)
		.then(response => response.json())
		.then((data) => {
			basketTotalItems.innerHTML = data.basketTotalItems;
		})
		.catch(error => {
			basketTotalItems.innerHTML = "0";
			console.log(error);
		});
	}
}

export const myApp = new App();


